module.exports = __webpack_public_path__ + "media/images/ui__arrowDown--dark-94cd7a5873e73bf92f35742c8e6cf47f.png";